import {Pipe, PipeTransform} from '@angular/core';

//  Questo pipe permette di formattare un testo contenente dei placeholder, sostituendoli con...
//  ...i valori corrispondenti passati come argomento

@Pipe({
  name: 'dtxt'
})
export class DtxtPipe implements PipeTransform {
  transform(rawText: string, data: { [key: string]: string }): { text: string, unresolved: string[] } {
    const returnValue = {
      text: '',
      unresolved: [] as string[]
    };

    const placeholdersValues = Object.entries(data);

    if (!placeholdersValues.length) {
      returnValue.text = rawText;
      return returnValue;
    }

    const regexpBrackets = new RegExp(/({{)(.*?)(}})/g);
    const placeholders = rawText.match(regexpBrackets);
    if (!placeholders?.length) {
      returnValue.text = rawText;
      return returnValue;
    }

    returnValue.text = rawText;
    placeholders.forEach((placeholder) => {
      const key = placeholder.replace('{{', '').replace('}}', '');
      const value = placeholdersValues?.find(([_key]) => _key === key)?.[1];
      if (value?.length) {
        returnValue.text = returnValue.text.replace(new RegExp(placeholder, 'g'), value);
        return;
      }
      returnValue.text = returnValue.text.replace(new RegExp(placeholder, 'g'), '');
      if (returnValue.unresolved.includes(key)) {
        return;
      }
      returnValue.unresolved.push(key);
    });
    return returnValue;
  }
}
